import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import { useAuth } from "@hl/shared-features/lib/features/auth/AuthContext";
import { SignInButton } from "@hl/shared-features/lib/features/auth/SignInButton";
import { Button, Text } from "@mantine/core";

import { useSeedRefreshEmbedCommandListeners } from "../embed/embed-commands";
import { useSeedRefreshEmbedEvents } from "../embed/embed-events";

import useBitstreamSeedRefresh from "./useBitstreamSeedRefresh";

export const BitstreamSeedRefreshEmbed = ({
  collectionId,
}: {
  collectionId: string;
}) => {
  const { emitSeedRefreshInitiated, emitSeedRefreshFinished } =
    useSeedRefreshEmbedEvents({ collectionId });
  const {
    setSeed,
    setTokenId,
    error,
    startSeedRefresh,
    buttonLabel,
    buttonDisabled,
  } = useBitstreamSeedRefresh({
    collectionId,
    emitSeedRefreshInitiated,
    emitSeedRefreshFinished,
  });

  useSeedRefreshEmbedCommandListeners({
    collectionId,
    setSeed,
    setTokenId,
  });

  const { authenticated } = useAuth();

  return (
    <>
      {!authenticated && <SignInButton />}
      {authenticated && (
        <>
          <Button
            fullWidth
            size="lg"
            type="submit"
            disabled={buttonDisabled}
            onClick={startSeedRefresh}
          >
            {buttonLabel || "Refresh seed"}
          </Button>
          {error && (
            <Text align="center" mt="xs" size="xs" color={STATUS_COLOR.ERROR}>
              {error}
            </Text>
          )}
        </>
      )}
    </>
  );
};
